module.exports = __webpack_public_path__ + "media/icons/salonowy-grey@2x-c4571902.png";